var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhychoose1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "typcn:tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.2149 7.81361C20.9279 7.65409 20.6123 7.55267 20.2861 7.51515C19.9598 7.47763 19.6294 7.50474 19.3137 7.59494C18.998 7.68513 18.7031 7.83664 18.4459 8.0408C18.1888 8.24497 17.9743 8.4978 17.8149 8.78486L13.1736 17.1374L10.5174 14.4811C10.2868 14.2423 10.0109 14.0519 9.70591 13.9209C9.4009 13.7898 9.07285 13.7209 8.7409 13.718C8.40895 13.7151 8.07975 13.7784 7.77251 13.9041C7.46527 14.0298 7.18614 14.2154 6.95141 14.4501C6.71668 14.6849 6.53105 14.964 6.40534 15.2712C6.27964 15.5785 6.21639 15.9077 6.21927 16.2396C6.22216 16.5716 6.29112 16.8996 6.42214 17.2046C6.55317 17.5096 6.74362 17.7855 6.9824 18.0161L11.9824 23.0161C12.4549 23.4899 13.0924 23.7499 13.7499 23.7499L14.0961 23.7249C14.4793 23.6713 14.8449 23.5294 15.1639 23.3106C15.483 23.0917 15.7469 22.8018 15.9349 22.4636L22.1849 11.2136C22.3445 10.9267 22.446 10.6111 22.4836 10.285C22.5212 9.9588 22.4942 9.62843 22.4041 9.3127C22.314 8.99698 22.1626 8.70209 21.9586 8.44488C21.7546 8.18766 21.5018 7.97315 21.2149 7.81361Z",
    fill: "#020617"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhychoose1);
export default __webpack_public_path__ + "static/media/whychoose_1.4a424c652c2c18f7536d6db727d66c17.svg";
export { ForwardRef as ReactComponent };